<template>
  <ul class="space-y-4">
    <li v-for="({ label, text, thumbnail }, key) in data" :key class="flex items-center gap-4">
      <div v-if="showThumbnails" class="w-12 shrink-0">
        <base-picture
          v-if="thumbnail"
          :alt="label"
          class="shrink-0"
          fit="contain"
          height="48"
          :src="thumbnail"
          width="48"
        />
      </div>
      <div class="grow space-y-1">
        <p v-if="label" class="subtitle-4">
          {{ label }}
        </p>
        <p v-if="text" class="ws-pre-wrap" :class="showThumbnails ? 'body-4' : 'body-3'">
          {{ text }}
        </p>
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { ProductDetailContent } from '#types/product'

const props = defineProps<{
  data: ProductDetailContent[]
}>()

const showThumbnails = props.data?.some(({ thumbnail }) => !!thumbnail)
</script>
